import { Component, ChangeDetectionStrategy, input, output } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import type { ActionButtonDef } from './button-actions.types';

@Component({
  selector: 'app-button-actions',
  imports: [NzIconModule, NzTooltipModule],
  templateUrl: './button-actions.html',
  styleUrl: './button-actions.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonActions<T = any> {
  row = input.required<T>();
  actions = input.required<ActionButtonDef[]>();
  action = output<string>();

  emit(btn: ActionButtonDef, event: MouseEvent): void {
    event.stopPropagation();
    this.action.emit(btn.action);
  }

  isVisible(btn: ActionButtonDef): boolean {
    return btn.visible ? btn.visible(this.row()) : true;
  }

  isDisabled(btn: ActionButtonDef): boolean {
    return btn.disabled ? btn.disabled(this.row()) : false;
  }
}
